module.exports = __webpack_public_path__ + "static/media/sub-category-icon.2a8b5ed9.svg";